import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, Container, Link } from '@mui/material';

import { url ,fileUploadUrl} from "../../../../constant";

const HomeFooter = () => {

  const [loading, setLoading] = useState(false);
  // Sample static data for footer links
  const [links, setLinks] = useState([
    {
      id: 1,
      link_text: "Privacy Policy",
      link_url: "/privacy-policy",
      footer_section_id: "About Us",
    },
    {
      id: 2,
      link_text: "Terms of Service",
      link_url: "/terms",
      footer_section_id: "About Us",
    },
    {
      id: 3,
      link_text: "Blog",
      link_url: "/blog",
      footer_section_id: "Resources",
    },
  ]);
  const [sections, setSections] = useState([]); // For dropdown of sections

  const failureSection = [
    {
      "id": 1,
      "section_title": "ShareITalents",
      "created_at": "2025-08-25T13:52:25.000000Z",
      "updated_at": "2025-09-01T11:20:16.000000Z"
    },
    {
      "id": 2,
      "section_title": "Collegamenti Rapidi",
      "created_at": "2025-08-25T13:52:25.000000Z",
      "updated_at": "2025-09-01T06:52:06.000000Z"
    },
    {
      "id": 3,
      "section_title": "Link Utili",
      "created_at": "2025-09-01T10:04:11.000000Z",
      "updated_at": "2025-09-01T10:36:43.000000Z"
    }
  ];

  const failureLinks = [
    {
      "id": 1,
      "footer_section_id": 1,
      "link_text": "La piattaforma intelligente per trovare e ottenere finanziamenti per la tua impresa.",
      "link_url": "#",
      "created_at": "2025-08-25T13:52:58.000000Z",
      "updated_at": "2025-09-01T10:37:37.000000Z"
    },
    {
      "id": 11,
      "footer_section_id": 2,
      "link_text": "Login",
      "link_url": "/authentication/sign-in",
      "created_at": "2025-09-01T10:05:21.000000Z",
      "updated_at": "2025-09-01T10:38:40.000000Z"
    },
    
    {
      "id": 12,
      "footer_section_id": 3,
      "link_text": "Synova",
      "link_url": "https://www.synova.it",
      "created_at": "2025-09-01T10:05:40.000000Z",
      "updated_at": "2025-09-01T10:39:51.000000Z"
    },
   
    
    
  ]


  useEffect(() => {
    fetchFooterLinks();
    fetchFooterSections();
  }, []);

  const fetchFooterLinks = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${url}auth/get-footer-links`);
      if (!res.ok) throw new Error(`Error: ${res.status}`);

      const data = await res.json();

      console.log("get-footer-links", data);

      if (Array.isArray(data) && data.length > 0) {
        setLinks(data);
      } else {
        console.log("Using default footer links due to empty API response.");
        setLinks(failureLinks);
      }

      // setLinks(data);
    } catch (err) {
      console.log("Footer links fetch failed. Using default content.", err);
      // Do NOT overwrite `links`, fallback will show
      setLinks(failureLinks);
    } finally {
      setLoading(false);
    }
  };

  const fetchFooterSections = async () => {
    try {
      const res = await fetch(`${url}auth/get-footer-sections`);
      if (!res.ok) throw new Error(`Error: ${res.status}`);
      const data = await res.json();

      console.log("get-footer-sections", data);

      if (Array.isArray(data) && data.length > 0) {
        setSections(data);
      } else {
        console.warn("Using default footer sections due to empty API response.");
        setSections(failureSection);
      }

      // setSections(data);
    } catch (error) {
      console.error("Failed to fetch footer sections. Using default.", error);
      setSections(failureSection);
    }
  };

  // Helper: Get links for a section with max 3 links
  const getLinksForSection = (sectionId) => {
    return links
      .filter(link => link.footer_section_id === sectionId && link.link_text && link.link_url)
      .slice(0, 3); // Max 3 links
  };


  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#f4f7fa',
        p: 5,
        color: '#1f2937',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <Grid container maxWidth="xl" margin="0 auto" spacing={4} justifyContent="space-between">
        {sections.map(section => (
          <Grid item xs={12} sm={4} key={section.id}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              {section.section_title}
            </Typography>
            <Box>
              {getLinksForSection(section.id).map(link => (
                <Link
                  key={link.id}
                  href={link.link_url}
                  underline="none"
                  color="text.secondary"
                  sx={{ display: 'block', mb: 1, cursor: 'pointer', fontSize: '0.875rem' }}
                  target={link.link_url.startsWith('http') ? "_blank" : "_self"}
                  rel={link.link_url.startsWith('http') ? "noopener noreferrer" : ""}
                >
                  {link.link_text}
                </Link>
              ))}
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Copyright */}
      <Box textAlign="center" mt={5} color="text.secondary" fontSize="0.75rem">
        © 2025 ShareITalents. Tutti i diritti riservati.
      </Box>
    </Box>
  );

  // return (
  //   <Box
  //     component="footer"
  //     sx={{
  //       backgroundColor: '#f4f7fa',
  //       p: 5,
  //       color: '#1f2937',
  //       fontFamily: 'Arial, sans-serif',
  //     }}
  //   >
  //     <Grid container maxWidth="xl" margin="0 auto" spacing={4} justifyContent="space-between">
  //       {/* Column 1 */}
  //       <Grid item xs={12} sm={4}>
  //         <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
  //           ShareITalents
  //         </Typography>
  //         <Typography variant="body2" color="text.secondary" lineHeight={1.4}>
  //           La piattaforma intelligente per trovare e ottenere finanziamenti per la tua impresa.
  //         </Typography>
  //       </Grid>

  //       {/* Column 2 */}
  //       <Grid item xs={12} sm={4}>
  //         <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
  //           Collegamenti Rapidi
  //         </Typography>
  //         <Box>
  //           <Link href="/authentication/sign-in" underline="none" color="text.secondary" sx={{ display: 'block', mb: 1, cursor: 'pointer', fontSize: '0.875rem' }}>
  //             Accedi
  //           </Link>
  //         </Box>
  //       </Grid>

  //       {/* Column 3 */}
  //       <Grid item xs={12} sm={4}>
  //         <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
  //           Link Utili
  //         </Typography>
  //         <Box>
  //           <Link href="https://www.synova.it" target="_blank"
  //             rel="noopener noreferrer" underline="none" color="text.secondary" sx={{ display: 'block', mb: 1, cursor: 'pointer', fontSize: '0.875rem' }}>
  //             Synova
  //           </Link>
  //         </Box>
  //       </Grid>
  //     </Grid>

  //     {/* Copyright */}
  //     <Box textAlign="center" mt={5} color="text.secondary" fontSize="0.75rem">
  //       © 2025 ShareITalents. Tutti i diritti riservati.
  //     </Box>
  //   </Box>
  // );
};

export default HomeFooter;

